type Props = {
  id: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

/**
 * A switch that works with the portal's Tailwind (the shadcn one styles itself
 * through data-attribute variants this Tailwind version does not generate).
 * The button is the 44 x 40 touch target; the track inside is what shows.
 */
export function ToggleSwitch({ id, checked, disabled = false, onChange }: Readonly<Props>) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className="shrink-0 min-w-[44px] min-h-[40px] flex items-center justify-center rounded-full cursor-pointer disabled:cursor-not-allowed disabled:opacity-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-700"
    >
      <span
        className={`relative block w-11 h-6 rounded-full transition-colors ${
          checked ? "bg-[#165FE3]" : "bg-[#767B86]"
        }`}
      >
        <span
          className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white-A700 shadow transition-transform ${
            checked ? "translate-x-5" : ""
          }`}
        />
      </span>
    </button>
  );
}
